import { Controller } from "@hotwired/stimulus"
import loadLiff from "../src/authen/load_liff.js"

// ปุ่ม "ส่งให้เพื่อน" — เปิดตัวเลือกเพื่อน/กลุ่มของ LINE แล้วส่งการ์ด Flex เข้าแชทให้เลย
// ข้อความที่ผู้ใช้ส่งเองไม่กินโควตา OA และไปถึงคนที่ยังไม่ได้เป็นเพื่อน OA ด้วย
//
// กับดักที่ต้องระวัง (เจอมาแล้วกับ LIFF flow เดิม):
//   - liff.init() ใน LIFF browser จะ auto-login เด้งไป access.line.me เองเมื่อ token เครื่องเสีย
//     ห้ามเรียกตอนโหลดหน้า ไม่งั้นคนที่ token พังจะโดนลากออกจากหน้าที่กำลังอ่านอยู่
//     → init ตอน "กดปุ่ม" เท่านั้น และพังเมื่อไหร่ก็ตกไป fallback ไม่ปล่อยไปตายที่จอ 400
//   - นอกแอป LINE (เดสก์ท็อป/เบราว์เซอร์ปกติ) ไม่มี shareTargetPicker → ใช้ line.me/R/share แทน
//     ได้แค่ข้อความกับลิงก์ ไม่ได้การ์ดสวย แต่แชร์ได้จริงทุกเครื่อง
export default class LineShareController extends Controller {
  static values = {
    message: Object,  // การ์ด Flex ที่ LineShareCard สร้างมา
    text: String,     // ข้อความสำรองตอนแชร์นอกแอป LINE
    url: String       // ลิงก์ที่แนบไปกับข้อความสำรอง
  }
  static targets = ["button"]

  async share(event) {
    event?.preventDefault()
    this.setBusy(true)

    try {
      // SDK โหลดตอนกดปุ่มเท่านั้น (ไม่ถ่วงหน้า) — นอกแอป LINE ไม่ต้องโหลดเลย ข้ามไปลิงก์แชร์
      const liff = /\bLine\//i.test(navigator.userAgent) ? await loadLiff() : null
      if (liff?.isInClient() && await this.ready(liff) && liff.isApiAvailable("shareTargetPicker")) {
        const result = await liff.shareTargetPicker([this.messageValue])
        // result เป็น null = ผู้ใช้กดปิดหน้าต่างเลือกเพื่อน ไม่ใช่ความผิดพลาด อย่าขึ้น error
        if (result) this.flash("ส่งให้เพื่อนแล้ว")
        return
      }
    } catch (e) {
      console.warn("[line share] shareTargetPicker ใช้ไม่ได้ ตกไปใช้ลิงก์แชร์แทน", e)
    } finally {
      this.setBusy(false)
    }

    this.shareByUrl()
  }

  // liff.init เรียกซ้ำได้ปลอดภัย (SDK จำสถานะเอง) แต่ยังต้องกันไม่ให้ init ค้างจนปุ่มไม่ตอบสนอง
  async ready(liff) {
    const liffId = document.getElementById("liffid")?.content
    if (!liffId) return false

    try {
      await Promise.race([
        liff.init({ liffId }),
        new Promise((_, reject) => setTimeout(() => reject(new Error("liff.init timeout")), 4000))
      ])
      return liff.isLoggedIn()
    } catch (e) {
      console.warn("[line share] liff.init ไม่ผ่าน", e)
      return false
    }
  }

  // ทางสำรอง: หน้าต่างแชร์ของ LINE แบบ URL scheme — ไม่ต้องมี SDK ใช้ได้นอกแอปด้วย
  shareByUrl() {
    const text = [this.textValue, this.urlValue].filter(Boolean).join("\n")
    window.open(`https://line.me/R/share?text=${encodeURIComponent(text)}`, "_blank", "noopener")
  }

  setBusy(busy) {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = busy
    this.buttonTarget.classList.toggle("opacity-60", busy)
  }

  flash(message) {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = message
    setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
  }
}
